module.exports = __webpack_public_path__ + "public/Icons/ratings.svg?438c4086";